import type { PatchRelease } from "../types";

export const release: PatchRelease = {
  id: "2026-06-10_01",
  version: "2026.06.10",
  date: "10 Jun 2026",
  sinceCommit: "38625a8",
  gameplay: [
    {
      text: "Spell slows no longer stack on top of the void edge slow — over the rim you only feel the natural void drag.",
    },
    {
      text: "Skill Draft picks advance **per player** — you are not held waiting for others to finish their step.",
    },
    {
      text: "Mobility spells (**Swap**, Teleport, Thrust) now share one ruleset: blocked while **Frost Nova**-frozen; still usable while channeling **Scourge** (walking stays locked). Previously only Teleport and Thrust were treated this way.",
    },
    {
      text: "When two hostile projectiles collide, they erupt with an expanding shockwave (14 damage, 0.12s stun, 1.35× knockback) instead of vanishing — the ring knocks back anyone in its path, including the colliding casters, and is blocked by pillars.",
    },
    {
      text: "When a round is decided, combat freezes — projectiles, DoTs, channels, and void drain stop, while knocked wizards still finish falling or coast to a stop.",
    },
  ],
  skills: [
    {
      spellId: "barrier",
      changes: [
        {
          text: "Damage absorbed **260 → 230**\nDuration **5s → 4.5s**\nCooldown **30s → 32s**",
        },
      ],
    },
    {
      spellId: "blizzard",
      changes: [
        {
          text: "Tick damage **38 → 34**\nZone duration **5s → 4.5s**\nCooldown **24s → 26s**",
        },
      ],
    },
    {
      spellId: "boomerang",
      changes: [
        { text: "Damage **40 → 44**" },
        {
          text: "Returning boomerangs no longer despawn mid-flight; return steering respects your move-speed bonuses.",
        },
      ],
    },
    {
      spellId: "bonespear",
      changes: [
        {
          text: "Damage **96 → 118**\nCooldown **22s → 19s**\nWindup **1.2s → 1.0s**\nSelf slow **70% → 82%**\nSelf slow duration **5s → 2.5s**\nVictim bleed **0.14 → 0.12** HP per unit moved",
        },
      ],
    },
    {
      spellId: "chainmend",
      changes: [
        { text: "Heal **38 → 44**\nCooldown **9s → 8.5s**" },
      ],
    },
    {
      spellId: "frozenorb",
      changes: [
        { text: "Orb hit damage **90 → 86**\nCooldown **26s → 28s**" },
      ],
    },
    {
      spellId: "homing",
      changes: [
        {
          text: "Damage **44 → 38**\nCooldown **9.6s → 12s**\nSpeed **500 → 470**\nLifetime **2.8s → 2.4s**\nStun **0.28s → 0.26s**",
        },
        { text: "Bolt flies straight for a short distance before it starts tracking — easier to sidestep." },
        {
          text: "Locks onto the enemy on your aim line when you cast (not whoever is closest when tracking starts), leads their movement, and won't retarget mid-flight.",
        },
      ],
    },
    {
      spellId: "icelance",
      changes: [
        { text: "Projectile speed **380 → 540** (matches Fireball travel time)." },
      ],
    },
    {
      spellId: "fireball",
      changes: [
        {
          passiveId: "fireball_multishot",
          text: "Side bolts deal **75%** damage (**25%** if all three land on one target). Only one bolt from a volley knocks back per enemy, at full spell knock strength.",
        },
      ],
    },
    {
      spellId: "illusionist",
      changes: [
        { text: "Cooldown **38s → 42s**\nDecoy duration **10s → 8s**" },
      ],
    },
    {
      spellId: "meteor",
      changes: [
        { text: "Blast damage **96 → 104**\nCooldown **28s → 26s**" },
        {
          text: "The ground hit indicator (blast radius and reticle) is only visible to you and your teammates — enemies no longer see where it will land.",
        },
      ],
    },
    {
      spellId: "rush",
      changes: [
        { text: "Duration **4s → 3s**\nMove speed bonus **+50% → +100%**" },
        { text: "Move speed bonus **+100% → +70%**" },
      ],
    },
    {
      spellId: "scourge",
      changes: [
        {
          text: "Center blast damage **64 → 150**\nEdge blast damage **26 → 100**\nSelf damage **120 → 50**",
        },
      ],
    },
    {
      spellId: "swap",
      changes: [
        { text: "Cooldown **36s → 30s**\nBolt speed **1100 → 1150**\nLifetime **1.2s → 1.35s**" },
      ],
    },
    {
      spellId: "voidbeam",
      changes: [
        { text: "Damage **118 → 124**\nMax charge time **1.4s → 1.25s**" },
        { text: "Full-charge self knockback reduced." },
      ],
    },
    {
      spellId: "windwalk",
      changes: [
        { text: "Cooldown **44s → 38s**\nStealth duration **4s → 4.5s**\nSlam damage **80 → 88**" },
      ],
    },
  ],
};
